<template>
<el-form ref="judgmentForm" :inline="true" :model="academicDirectorJudgment" label-width="150px">
  <el-form-item label=" " v-if="isReappraisal && this.workingApplication.overdue">
    <el-alert :closable="false" type="warning" :title="OVERDUE_MESSAGE" show-icon=""
      style="border: 1px solid; background-color: #fdf6ec;"></el-alert>
  </el-form-item>
  <el-form-item label="Κατηγορία αίτησης" v-if="isReappraisal">
    <el-switch disabled v-model="workingApplication.legalIssue"
      active-text="Νομικό ζήτημα" inactive-text="Ακαδημαϊκό ζήτημα"></el-switch>
  </el-form-item>
  <internalComments></internalComments>
  <proposals></proposals>
  <el-form-item label="Εσωτερικό Σχόλιο">
    <el-input class="biggest" type="textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="Εισάγετε κείμενο για τον Πρόεδρο" v-model="academicDirectorJudgment.internalComment" @change="modifycomment"></el-input>
  </el-form-item>
  <!-- <el-form-item label="Εισήγηση" v-if="fromProponent">
    <el-input class="biggest" type="textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="Εισήγηση Διευθυντή Αναγν/σης (υποχρεωτική)" v-model="academicDirectorJudgment.proposal"></el-input>
  </el-form-item> -->
  <el-form-item label="Αντισταθμιστικά μέτρα" v-if="fromPresident">
    <el-input class="biggest" type="textarea" :autosize="{ minRows: 4, maxRows: 10}" placeholder="Ορισμός αντισταθμιστικών μέτρων (υποχρεωτικός)" v-model="academicDirectorJudgment.proposal"></el-input>
  </el-form-item>
  <el-form-item label="Πρακτικό Δ.Σ." v-if="isReappraisal">
    <el-upload v-loading="uploading"
        class="upload-demo"
        ref="uploadBoardMinutesOnReappRef"
        accept=".pdf"
        :file-list="boardMinutesOnReappAttachments"
        :http-request="addAttachment"
        :on-remove="handleRemove"
        :before-remove="handleBeforeRemove"
        :on-preview="viewPdf"
        :limit="1"
        action=""
        :auto-upload="true"
        :show-file-list="true">
        <el-button slot="trigger" size="small" type="primary" :disabled="this.boardMinutesOnReappAttachments.length >= 1">Ανέβασμα</el-button>
        <div class="el-upload__tip" slot="tip">** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα Πρακτικού Δ.Σ. για την εισήγηση της Ειδ. Επιτρ. Επανεξέτασης (pdf έως 12MB)</div>
      </el-upload>
  </el-form-item>
  <div style="text-align: center">
    <el-button size="mini" type="primary" round @click="tempSave()" v-if="!isReappraisal">Αποθήκευση</el-button>
    <el-button size="mini" type="danger" round="" @click="finalSave()" :disabled="!isValidForm">Οριστική Υποβολή</el-button>
  </div>
</el-form></template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import Proposals from '../common/Proposals'
import internalComments from '../common/internalComments'
import sharedMethods from '../common/sharedMethods.js'

export default {
  components: {
    Proposals,
    internalComments
  },
  mixins: [sharedMethods],
  mounted: function () {
  },
  props: ['application', 'comment'],
  data () {
    return {
      generalJudgment: '',
      appFinalSaved: false,
      modified: false,
      attachments: [],
      uploading: false
    }
  },
  methods: {
    addAttachment (file, fileList) {
      return this.getData(file.file).then(data => {
        let docType = 1015 // Board minutes on reappraisal board's proposal
        const url = `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments`
        console.log('>>> Doc type', docType)
        let payload = {
          type: docType,
          file: data,
          name: file.file.name,
          uuid: this.currentUser.id
        }
        return axios.post(url, payload)
          .then(res => {
            let id = res.data.data.id
            file.file.id = id
            this.uploading = false
            this.frontEndSuccessMsg('Η προσθήκη του εγγράφου πραγματοποιήθηκε με επιτυχία')
            let academicDirectorsAttached = this.boardMinutesOnReappAttachments.slice(0)
            let dispatchType = 'SET_BOARD_MINUTES_ON_REAPP_ATTACHMENTS'
            console.log('>>> Proponents attached', academicDirectorsAttached)
            console.log('>>> Set attachments type', dispatchType)
            academicDirectorsAttached[academicDirectorsAttached.length] = {type: payload.type, name: payload.name, uid: payload.uuid, id: id}
            this.$store.dispatch(dispatchType, academicDirectorsAttached)
          }).catch((response) => {
            this.frontEndError('Σφάλμα κατά την προσθήκη του εγγράφου')
          })
      })
    },
    getData (file) {
      return new Promise((resolve, reject) => {
        console.log('>>> Get data file', file)
        const fReader = new FileReader()
        let base64Pdf
        fReader.onload = (fileLoadedEvent) => {
          base64Pdf = fileLoadedEvent.target.result
          resolve(base64Pdf.split(',')[1])
        }
        fReader.readAsDataURL(file)
      })
    },
    handleRemove (file, fileList) {
      let dispatchType = 'SET_BOARD_MINUTES_ON_REAPP_ATTACHMENTS'
      return axios.delete(
        `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments/${file.id}`
      ).then(response => {
        this.$store.dispatch(dispatchType, this.boardMinutesOnReappAttachments.filter(attachment => attachment.id !== file.id))
      }).catch(err => {
        this.backendError(err)
        throw err
      })
    },
    handleBeforeRemove (file, fileList) {
      return this.$confirm(`Να αφαιρεθεί το ${file.name}？`)
    },
    viewPdf (file) {
      axios.get(`${this.BASE_URL}/users/uid/applications/${this.workingApplication.id}/attachments/${file.id}`)
        .then((response) => {
          const base64Data = encodeURI(response.data.data.file[0])
          this.openPdfWindow(file.name + ' (' + file.id + ')', base64Data)
        })
    },
    tempSave () {
      axios.put(
        `${this.BASE_URL}/academicdirectors/uid/applications/${this.workingApplication.id}/temp`,
        {
          judgment: {
            internalComment: this.academicDirectorJudgment.internalComment ? this.academicDirectorJudgment.internalComment : '',
            proposal: this.academicDirectorJudgment.proposal ? this.academicDirectorJudgment.proposal : null
          }
        }
      ).then((response) => {
        this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
        this.frontEndSuccessMsg('Η αίτηση αποθηκεύτηκε με επιτυχία')
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
        this.catchError(err)
      })
    },
    finalSave () {
      this.$confirm(`Η αίτηση προωθείται προς τον Πρόεδρο. Είστε σίγουροι ότι θέλετε να συνεχίσετε;`,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        axios.put(
          `${this.BASE_URL}/academicdirectors/uid/applications/${this.workingApplication.id}/final`,
          {
            judgment: {
              internalComment: this.academicDirectorJudgment.internalComment ? this.academicDirectorJudgment.internalComment : '',
              proposal: this.academicDirectorJudgment.proposal
              // proposal: this.academicDirectorJudgment.proposal ? this.academicDirectorJudgment.proposal : null
            }
          }
        ).then((response) => {
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.frontEndSuccessMsg('Η αίτηση προωθήθηκε με επιτυχία')
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
          this.catchError(err)
        })
      })
    },
    modifycomment (val) {
      this.modified = !(this.academicDirectorJudgment.internalComment === this.internalComment)
    },
    catchError (err) {
      this.backendError(err)
      throw err
    }
  },
  computed: {
    academicDirectorJudgment () {
      let h = this.application.applicationHistory
      return h[h.length - 1].judgment
    },
    // fromProponent () {
    //   return this.application.applicationHistory.slice(-1)[0].applicationStatus === 'academicDirectorW_Proponent'
    // },
    isReappraisal () {
      return this.workingApplication.applicationType === 'reappraisal'
    },
    fromPresident () {
      return this.application.applicationHistory.slice(-1)[0].applicationStatus === 'academicDirectorW_President'
    },
    // fromConsultantSecOverdue () {
    //   return this.application.applicationHistory.slice(-1)[0].applicationStatus === 'viewerW_President'
    // },
    isValidForm: function () {
      // if (this.academicDirectorJudgment.comment && (this.academicDirectorJudgment.comment === null || this.academicDirectorJudgment.comment.trim() === '')) {
      //   return false
      // }
      if (!this.isReappraisal && this.academicDirectorJudgment.proposal &&
        (this.academicDirectorJudgment.proposal === null || this.academicDirectorJudgment.proposal.trim() === '')) {
        return false
      }
      if (this.isReappraisal) {
        return this.boardMinutesOnReappAttachments.length === 1
      }
      return true
    },
    ...mapState([
      'workingApplication',
      'BASE_URL',
      'activeLane',
      'OVERDUE_MESSAGE',
      'boardMinutesOnReappAttachments'
    ]),
    ...mapGetters({ currentUser: 'currentUser' })
  },
  watch: {
    application: function (newVal, oldVal) {
      this.generalJudgment = this.comment
    },
    comment: {
      handler: function (newVal, oldVal) {
        this.generalJudgment = newVal
      },
      deep: true
    },
    // whenever value changes, this function will run
    pending: (newVal, oldVal) => {
      if (oldVal === true) this.comment = ''
    }
    // comment: (newComment, oldComment) => {
    //   if (newComment === 'the reason for pending') this.comment = ''
    // }
  }
}
</script>
<style scoped lang="scss">
.big {
  &.el-select {
    width: 450px;
  }
}
.biggest {
  &.el-textarea {
    width: 700px;
  }
}
.el-checkbox__label {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/AcademicDirectorJudgement.vue